import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'rwidget-navigate-away-modal',
  templateUrl: './navigate-away-modal.component.html',
  styleUrls: ['./navigate-away-modal.component.css']
})
export class NavigateAwayModalComponent {
  @Input() showNavigationModal = false;
  @Output() onConfirmNavigation: EventEmitter<any> = new EventEmitter();
  @Output() onCancelNavigation: EventEmitter<any> = new EventEmitter();

  @Input() translations = {
    title: 'SHOPPING_CART_LOCKED_NAVIGATION_MODAL_TITLE',
    text: 'SHOPPING_CART_LOCKED_NAVIGATION_MODAL_TEXT',
    textBold: 'SHOPPING_CART_LOCKED_NAVIGATION_MODAL_TEXT_BOLD',
    allowNavigation: 'SHOPPING_CART_ALLOW_NAVIGATION',
    cancel: 'SHOPPING_CART_ABOUT_TO_END_MODAL_CANCEL'
  }

  confirm() {
    this.onConfirmNavigation.emit();
  }

  cancel() {
    this.onCancelNavigation.emit();
  }

}
